"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var ECookieCategories_1 = require("./Interfaces/ECookieCategories");
var COOKIE_INFO = "cookie-info";
var CookiesConsent = /** @class */ (function () {
    function CookiesConsent(_a) {
        var $Cookies = _a.$Cookies, $AcceptedCookies = _a.$AcceptedCookies, Texts = _a.Texts, StatsData = _a.StatsData, Search = _a.Search, INTERNAL_API_URL = _a.INTERNAL_API_URL, VERSION_FILES_JS = _a.VERSION_FILES_JS;
        this.$Cookies = $Cookies;
        this.$AcceptedCookies = $AcceptedCookies;
        this.Texts = Texts;
        this.StatsData = StatsData;
        this.Search = Search;
        this.INTERNAL_API_URL = INTERNAL_API_URL;
        this.VERSION_FILES_JS = VERSION_FILES_JS;
        this.updateAcceptedCookies();
    }
    CookiesConsent.prototype.Accept = function (categories) {
        var _this = this;
        var cookieValue = JSON.stringify(categories);
        this.$Cookies.Set(COOKIE_INFO, cookieValue, 365 * 24);
        return axios_1.default.post(this.INTERNAL_API_URL + "/Cookies/Accepted", categories).then(function (_a) {
            var data = _a.data;
            _this.$AcceptedCookies.SaveAcceptedCookies(data);
            _this.sendConsentStat(categories);
        });
    };
    CookiesConsent.prototype.getConsentStatMessage = function (cookiesInfo) {
        var _a = this.Texts, NECESSARY_COOKIES_DESC = _a.NECESSARY_COOKIES_DESC, NECESSARY_COOKIES_DESC_BLOCK = _a.NECESSARY_COOKIES_DESC_BLOCK, FUNCTIONAL_COOKIES_DESC = _a.FUNCTIONAL_COOKIES_DESC, STATS_COOKIES_DESC = _a.STATS_COOKIES_DESC, MARKETING_COOKIES_DESC = _a.MARKETING_COOKIES_DESC, MARKETING_COOKIES_DESC_2 = _a.MARKETING_COOKIES_DESC_2;
        var complianceText = ECookieCategories_1.default.NECESSARY + ": " + NECESSARY_COOKIES_DESC + " " + NECESSARY_COOKIES_DESC_BLOCK;
        if (cookiesInfo.functional) {
            complianceText += "\n" + ECookieCategories_1.default.FUNCTIONAL + ": " + FUNCTIONAL_COOKIES_DESC;
        }
        if (cookiesInfo.performance) {
            complianceText += "\n" + ECookieCategories_1.default.PERFORMANCE + ": " + STATS_COOKIES_DESC;
        }
        if (cookiesInfo.targeting) {
            complianceText += "\n" + ECookieCategories_1.default.TARGETING + ": " + MARKETING_COOKIES_DESC + " " + MARKETING_COOKIES_DESC_2;
        }
        return complianceText;
    };
    CookiesConsent.prototype.sendConsentStat = function (cookiesInfo) {
        var _a = this, StatsData = _a.StatsData, $Cookies = _a.$Cookies, Search = _a.Search, INTERNAL_API_URL = _a.INTERNAL_API_URL;
        axios_1.default.post(INTERNAL_API_URL + "/Cookies/StatConsent", {
            city: StatsData.City,
            complianceText: this.getConsentStatMessage(cookiesInfo),
            integration: StatsData.Provider,
            platform: StatsData.Platform,
            search: Search,
            userToken: $Cookies.Get("usu_tiendeo"),
        });
    };
    CookiesConsent.prototype.getInfoCategories = function () {
        var value = this.$Cookies.Get(COOKIE_INFO);
        if (value && value !== "1") {
            return JSON.parse(value);
        }
        return {
            functional: true,
            necessary: true,
            performance: true,
            targeting: true,
        };
    };
    CookiesConsent.prototype.updateAcceptedCookies = function () {
        var acceptedCategories = this.getInfoCategories();
        var acceptedCookies = this.$AcceptedCookies.Get(acceptedCategories);
        var lastUpdateTime = this.$AcceptedCookies.GetLastUpdateTime();
        var lastVersion = this.$AcceptedCookies.GetLastVersion();
        var shouldUpdate = this.shouldUpdate(lastUpdateTime, lastVersion) || !acceptedCookies;
        if (!shouldUpdate) {
            return;
        }
        console.log("Updating accepted cookies...");
        this.$AcceptedCookies.UpdateAcceptedCookies(acceptedCategories);
    };
    CookiesConsent.prototype.shouldUpdate = function (lastUpdate, lastVersion) {
        if (!lastUpdate || !lastVersion) {
            return true;
        }
        var now = new Date();
        var ONE_HOUR = 60 * 60 * 1000;
        var timeSinceLastUpdate = Math.abs(now.getTime() - lastUpdate.getTime()) / ONE_HOUR;
        var isStale = timeSinceLastUpdate > 24;
        return isStale || lastVersion !== this.VERSION_FILES_JS;
    };
    return CookiesConsent;
}());
exports.default = CookiesConsent;
//# sourceMappingURL=CookiesConsent.js.map